import { type TabBarEntry } from '@/components/Tabs';
import { type CompanyDashboardDestinationKey } from '@/abilities/companyDashboard/vocabulary';

/** The dashboard tab bar, in the order it shows the tabs. Where the bare address leads is the tree's own order. */
export const companyDashboardTabBar: ReadonlyArray<TabBarEntry<CompanyDashboardDestinationKey>> = [
  {
    destination: 'vendorExpenses',
    label: { id: 'company.dashboard.vendorExpenses', defaultMessage: 'Vendor Expenses' },
  },
];
